'use client'

import styles from './AddToCard.module.scss'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { changeCountItems } from '@/shared/store/slice/cartSlice'
import { useAddProductToCartMutation } from '@/shared/api-rtk/api-list/cartApi'
import classNames from 'classnames'
import { useGetCartItemsQuery } from '@/shared/api-rtk'
import { redirect } from 'next/navigation'

export function AddToCart({ productId, item, cartContains }) {
    const dispatch = useDispatch()
    const navigate = (path) => redirect(path)
    const cert = item?.name == 'Подарочный сертификат'
    const { data: productsInCart, refetch } = useGetCartItemsQuery()

    const [addProductToCart, { isLoading, isError, error }] =
        useAddProductToCartMutation()

    const navigateToCart = () => {
        navigate('/cart')
    }

    const addItemCart = async () => {
        if (
            (productsInCart?.data.length > 0 && cert) ||
            (productsInCart?.data?.includes('187') && !cert)
        ) {
            toast.warn(
                'Вы можете одновременно заказать либо один Сертификат либо продукцию на нашем сайте.'
            )
        } else {
            try {
                const result = await addProductToCart({
                    product_id: productId,
                    quantity: 1,
                })
                const data = result.data
                if (!data.success) {
                }
                const total = parseInt(data.total.split(' ')[1])
                dispatch(changeCountItems(total))
                toast.success(data.total)
                refetch()
            } catch (error) {
                // console.log(error)
            }
        }
    }

    return (
        Number(item?.quantity) > 0 &&
        !cert && (
            <div
                className={'cart-item'}
                onClick={cartContains ? navigateToCart : () => addItemCart()}
            >
                <svg
                    className={classNames(
                        styles.icon,
                        cartContains ? styles.active : ''
                    )}
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    fill="none"
                    viewBox="0 0 26 26"
                >
                    <rect
                        width="24.25"
                        height="24.25"
                        x="0.732"
                        y="0.398"
                        stroke="#040404"
                        strokeWidth="2"
                        rx="4.625"
                    ></rect>
                    <path
                        stroke="#040404"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M6.696 6.273h.533c.335 0 .623.24.683.569l1.562 8.46h7.567a.694.694 0 00.677-.54L19 9.208a.694.694 0 00-.677-.85h-9.89m8.68 10.416a.694.694 0 110-1.388.694.694 0 010 1.388zm-6.944 0a.694.694 0 110-1.388.694.694 0 010 1.388z"
                    ></path>
                </svg>
            </div>
        )
    )
}
